export const COPY_TEXT = {
  LOADING_TEXT: "Loading options",
  SEARCH_FOR_RESULTS: "Type to narrow down (50+ options available).",
  NO_MATCH_FOUND: "No matches found. Try a different search term.",
  NO_ITEMS_AVAILABLE: "No items available."
};
